
import { defineComponent, onMounted } from "vue";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "app",
  setup() {
    if (process.env.NODE_ENV === "production") {
      if (location.protocol !== "https:") {
        location.replace(
          `https:${location.href.substring(location.protocol.length)}`
        );
      }
    }
    const store = useStore();
    let platformList = ["iPhone", "Android "];
    let sUsrAg = navigator.userAgent;

    // The order matters here, and this may report false positives for unlisted browsers.

    for (let index = 0; index < platformList.length; index++) {
      let element = sUsrAg.indexOf(platformList[index]);
      if (element > -1) {
        store.state.platform = true;
        break;
      }
    }

    onMounted(() => {
      /**
       * this is to override the layout config using saved data from localStorage
       * remove this to use config only from static config (@/core/config/DefaultLayoutConfig.ts)
       */
      store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);
    });
  },
});
